/**
 * Realtime runs on the real project. The local dev stack has none (docs/DEVELOPMENT.md),
 * and a websocket that cannot connect fills every page's console with errors, so on
 * localhost the bell only polls — unless VITE_REALTIME=on (e.g. `supabase start`).
 */
export function realtimeAvailable(url: string | undefined, flag: string | undefined): boolean {
  if (flag === 'on') return true;
  if (flag === 'off' || !url) return false;
  try {
    return !/^(localhost|127\.0\.0\.1|\[::1\])$/.test(new URL(url).hostname);
  } catch {
    return false;
  }
}
